import * as React from 'react';
import { FontSizes, Icon, NeutralColors } from "@fluentui/react";

interface IHeaderPanelStyle1 {
  nameIconHeader?: string | undefined;
  textHeader: string;
  subTextHeader: string;
  fontSize?: string;
}
export const PanelHeader = (props: IHeaderPanelStyle1) => {
  return (
    <>
      <div
        style={{
          margin: props.nameIconHeader != undefined ? "10px 2.5rem": "10px 1.5rem",
          display: "flex",
          flexDirection: "row",
          alignItems: "center", // Alinea verticalmente el contenido
          width: "100%",
          height: "60px",
        }}
      >
        {props.nameIconHeader != null && props.nameIconHeader != undefined ? (
          <>
            <div>
              <Icon
                iconName={props.nameIconHeader}
                styles={{
                  root: {
                    fontSize:
                      props.fontSize != null && props.fontSize != null
                        ? props.fontSize
                        : "40px",
                    color: "#0078d4",
                  },
                }}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 20px",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            {props.textHeader}
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          >
            {props.subTextHeader}
          </div>
        </div>
      </div>
    </>
  );
};
